var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"export"},[_c('pre',[_vm._v("    "+_vm._s(JSON.stringify(_vm.data, null, 2))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }